import { useLocale } from 'next-intl'
import Link from 'next/link'
import React from 'react'

export default function LinkLocale({ href, ...props }) {
  const locale = useLocale()
  const isExternal = href.startsWith('http')
  const hrefWithLocale = isExternal ? href : `/${locale}${href}`
  return <Link href={hrefWithLocale} {...props} />
}
